import { createUrl } from 'app/utils';
import { Box, Flex, Icons, Page, Section, Typography } from 'components';
import SubmenuVertical from 'components/submenuVertical';
import { HeaderPerfil } from 'features/account/components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Icon = styled(Icons)`
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.gray_500};
`;

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  left: 0;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    z-index: 1000;
  }

  &::before {
    content: '';
    display: block;

    border-top: 2px solid ${({ theme }) => theme.colors.white25};
    border-right: 2px solid ${({ theme }) => theme.colors.white25};
    position: absolute;

    right: 0px;
    z-index: 1;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.mobile} {
      top: 1px;
      left: -25px;

      &::after {
        width: 14px;
        height: 14px;
      }

      &::before {
        top: -30px;
        width: 150px;
        height: 230px;
      }
    }

    ${mediaQueries.tablet} {
      left: -30px;

      &::after {
        width: 14px;
        height: 14px;
        top: 3px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 100px;
        height: 150px;
      }
    }

    ${mediaQueries.desktop} {
      top: 4px;
      left: -40px;

      &::after {
        width: 17px;
        height: 17px;
        top: 0px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 150px;
        height: 280px;
      }
    }
  `;
  }}
`;

interface DocumentProps {
  documentText: string;
}
const DocumentsView = () => {
  const documents: DocumentProps[] = [
    { documentText: 'Declaração de matrícula Geral' },
    { documentText: 'Declaração de Previsão de término do curso' },
    { documentText: 'Carta de apreentação de estágio' },
  ];
  const navigate = useNavigate();
  const [subAreaIndex, setSubAreaIndex] = useState(0);

  return (
    <Page title="Meu Perfil">
      <HeaderPerfil areaIndex={4} onAreaClick={(value) => navigate(createUrl(value))} />
      <Flex flexDirection="row" bg="white">
        <SubmenuVertical areas={['Documentos acadêmicos', 'Contratos']} areaIndex={subAreaIndex} onAreaClick={(index) => setSubAreaIndex(index)} />
        <Flex py={{ m: 30, t: 60, d: 90 }} bg="white" flexGrow={0} marginLeft="10%">
          <Section flex={1} flexDirection={{ m: 'column', d: 'row' }} flexWrap="wrap">
            {subAreaIndex === 0
              ? documents?.map((document, index) => {
                  return (
                    <Flex flexGrow={0} key={index} mb="4" mr={6}>
                      <Flex height={180} width={280} bg="white" borderRadius={4} onClick={() => {}} style={{ cursor: 'pointer' }}>
                        <Flex flexDirection="column" alignItems="flex-start" paddingY={16} paddingX={20}>
                          <Typography type="type0" color="gray_400" upper mb={2}>
                            Documento
                          </Typography>
                          <Typography type="type3" color="black" fontWeight="bold">
                            {document.documentText}
                          </Typography>
                        </Flex>
                        <Flex
                          mt={2}
                          width="100%"
                          height={40}
                          alignItems="center"
                          alignSelf="flex-end"
                          justifyContent="space-between"
                          bg="gray_100"
                          p={2}
                        >
                          <Typography type="type1" color="gray_500" upper fontWeight="bold">
                            Solicitar Documento
                          </Typography>
                          <Icon icon="fileDocumentOutline" />
                        </Flex>
                      </Flex>
                    </Flex>
                  );
                })
              : null}
          </Section>
        </Flex>
      </Flex>
    </Page>
  );
};

export default DocumentsView;
